import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { presetDates } from '../utils/variables';

const PresetDateFilter = ({ filterValue, updateFilters, disabled = false }) => {
  return (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel id="time-frame">Time Frame</InputLabel>
      <Select
        labelId="select-label"
        id="select"
        disabled={disabled}
        fullWidth={true}
        value={filterValue}
        label="Time Frame"
        onChange={(event) => updateFilters(event.target.value)}
      >
        {Object.keys(presetDates).map((key) => (
          <MenuItem key={key} value={key}>
            {presetDates[key]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PresetDateFilter;
